import { plans } from './plans'

// Usuário pode receber mais convites, participar de mais equipes?
export function canMoreInvites(user) {
  let canMore = false
  const qtd = user.contas.length
  const plano = user.plano.toLocaleUpperCase()
  switch (plano) {
    case plans.planUser.title.toLocaleUpperCase():
      if (qtd < plans.planUser.equipes.qtd) canMore = true
      break
    case plans.planSingle.title.toLocaleUpperCase():
      if (qtd< plans.planSingle.equipes.qtd) canMore = true 
      break
    case plans.planTeam.title.toLocaleUpperCase():
      if (qtd < plans.planTeam.equipes.qtd) canMore = true 
      break  
    case plans.planFree.title.toLocaleUpperCase():
      if (qtd < plans.planFree.equipes.qtd) canMore = true 
      break
    case plans.planAdm.title.toLocaleUpperCase():
      if (qtd < plans.planAdm.equipes.qtd) canMore = true
      break
    case plans.planBusiness.title.toLocaleUpperCase():
      if (qtd < plans.planBusiness.equipes.qtd) canMore = true
      break
    case plans.planAdvanced.title.toLocaleUpperCase():
      if (qtd < plans.planAdvanced.equipes.qtd) canMore = true
      break
    case plans.planBroker.title.toLocaleUpperCase():
      if (qtd < plans.planBroker.equipes.qtd) canMore = true
      break
    default:
      if (qtd <= 1) canMore = false
      break
  }
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('canMoreInvites', canMore, plano, qtd)
  return canMore
}

// Usuário pode Entrar na Equipe
export function canUserJoinTeam(qtd, plano) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('canUserJoinTeam', qtd, plano)
  let canJoin = false
  switch (plano) {
    case plans.planUser.title.toLocaleUpperCase():
      if (qtd < plans.planUser.equipes.integrantes) canJoin = true
      break
    case plans.planSingle.title.toLocaleUpperCase():
      if (qtd < plans.planSingle.equipes.integrantes) canJoin = true
      break
    case plans.planTeam.title.toLocaleUpperCase():
      if (qtd < plans.planTeam.equipes.integrantes) canJoin = true
      break
    case plans.planBroker.title.toLocaleUpperCase():
      if (qtd < plans.planBroker.equipes.integrantes) canJoin = true
      break
    case plans.planAdm.title.toLocaleUpperCase():
      if (qtd < plans.planAdm.equipes.integrantes) canJoin = true
      break
    case plans.planFree.title.toLocaleUpperCase():
      if (qtd < plans.planFree.equipes.integrantes) canJoin = true
      break
    case plans.planBusiness.title.toLocaleUpperCase():
      if (qtd < plans.planBusiness.equipes.integrantes) canJoin = true
      break
    case plans.planAdvanced.title.toLocaleUpperCase():
      if (qtd < plans.planAdvanced.equipes.integrantes) canJoin = true
      break
    default:
      canJoin = false
      break
  }
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('canUserJoinTeam', canJoin, plano, qtd, plans.planAdvanced.title.toLocaleUpperCase())
  return canJoin
}

// Usuário pode Enviar mais Convites
export function canUserSendInvite(user, qtd) {
  let canSend = false
  const plano = user.plano.toLocaleUpperCase()
  switch (plano) {
    case plans.planUser.title.toLocaleUpperCase():
      if (qtd < plans.planUser.equipes.integrantes) canSend = true
      break      
    case plans.planFree.title.toLocaleUpperCase():
      if (qtd < plans.planFree.equipes.integrantes) canSend = true
      break
    case plans.planSingle.title.toLocaleUpperCase():
      if (qtd < plans.planSingle.equipes.integrantes) canSend = true
      break
    case plans.planTeam.title.toLocaleUpperCase():
      if (qtd < plans.planTeam.equipes.integrantes) canSend = true
      break
    case plans.planBroker.title.toLocaleUpperCase():
      if (qtd < plans.planBroker.equipes.integrantes) canSend = true
      break
    case plans.planAdm.title.toLocaleUpperCase():
      if (qtd < plans.planAdm.equipes.integrantes) canSend = true
      break
    case plans.planBusiness.title.toLocaleUpperCase():
      if (qtd < plans.planBusiness.equipes.integrantes) canSend = true
      break
    case plans.planAdvanced.title.toLocaleUpperCase():
      if (qtd < plans.planAdvanced.equipes.integrantes) canSend = true
      break
    default:
      canSend = false
      break
  }
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('canSendInvite',qtd, canSend, plano, user)
  return canSend
}

// Usuário pode ser Operador de Outra equipe
export function canBeOperator(user) {
  let canBe = false
  const qtd = user.contas.length
  const plano = user.plano.toLocaleUpperCase()
  switch (plano) {
    case plans.planFree.title.toLocaleUpperCase():
      if (qtd < plans.planFree.equipes.qtd) canBe = true
      break
    case plans.planUser.title.toLocaleUpperCase():
      if (qtd < plans.planUser.equipes.qtd) canBe = true
      break      
    case plans.planSingle.title.toLocaleUpperCase():
      if (qtd < plans.planSingle.equipes.qtd) canBe = true
      break
    case plans.planTeam.title.toLocaleUpperCase():
      if (qtd < plans.planTeam.equipes.qtd) canBe = true
      break
    case plans.planBroker.title.toLocaleUpperCase():
      if (qtd < plans.planBroker.equipes.qtd) canBe = true
      break
    case plans.planAdm.title.toLocaleUpperCase():
      if (qtd < plans.planAdm.equipes.qtd) canBe = true
      break
    case plans.planBusiness.title.toLocaleUpperCase():
      if (qtd < plans.planBusiness.equipes.qtd) canBe = true
      break
    case plans.planAdvanced.title.toLocaleUpperCase():
      if (qtd < plans.planAdvanced.equipes.qtd) canBe = true
      break
    default:
      canBe = false
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('plano', plano, qtd)
      break
  }
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('canBe', canBe, plano, qtd)
  return canBe
}

// Usuário pode ter Equipe
export function canTeam(user) {
  if (user.plan?.team) return user.plan.team
  else return false
}

// Usuário pode Editar Imóveis
export function canEdit(user) {
  // Usuário Plano User aguardando CONVITE não pode Editar
  if (user.plano === plans.planUser.title.toLocaleUpperCase() && user.rules[0] === plans.planAdm.rule.title) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('CanEdit', user, false)
    return false
  }
  else {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('CanEdit', user, user.permissions.includes('write'))
    return user.permissions.includes('write')
  }

}

export function canFilter(user){
   // Usuário Plano User aguardando CONVITE não pode Filtrar
  if (user.plano === plans.planUser.title.toLocaleUpperCase() && user.rules[0] === plans.planAdm.rule.title) {
    if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('CanEdit', user, false)
    return false
  }
  else return user.permissions.includes('filter')
}

export function planHasCRM(user){
  let hasCRM = false
  const plano = user.plano.toLocaleUpperCase()
  switch (plano) {
    case plans.planUser.title.toLocaleUpperCase():
       hasCRM = plans.planUser.crm
      break
    case plans.planSingle.title.toLocaleUpperCase():
      hasCRM = plans.planSingle.crm
      break
    case plans.planTeam.title.toLocaleUpperCase():
      hasCRM = plans.planTeam.crm
      break
    case plans.planAdm.title.toLocaleUpperCase():
      hasCRM = plans.planAdm.crm
      break
    case plans.planBusiness.title.toLocaleUpperCase():
      hasCRM = plans.planBusiness.crm
      break
    case plans.planAdvanced.title.toLocaleUpperCase():
      hasCRM = plans.planAdvanced.crm
      break
    case plans.planFree.title.toLocaleUpperCase():
      if (user.conta !== user.id) hasCRM = false
      else hasCRM = plans.planFree.crm
      break
    case plans.planBroker.title.toLocaleUpperCase():
      hasCRM = plans.planBroker.crm
      break
    default:
      hasCRM = false
      break
  }
  return hasCRM
}